import { render, staticRenderFns } from "./HeaderServicoIntervencao.vue?vue&type=template&id=a06b5f42"
import script from "./HeaderServicoIntervencao.vue?vue&type=script&lang=js"
export * from "./HeaderServicoIntervencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports